import { render } from "./RecordAudio.vue?vue&type=template&id=4aafc54b&scoped=true"
import script from "./RecordAudio.vue?vue&type=script&lang=js"
export * from "./RecordAudio.vue?vue&type=script&lang=js"

import "./RecordAudio.vue?vue&type=style&index=0&id=4aafc54b&lang=less&scoped=true"

import exportComponent from "/home/lyramdc/Projects/face/ACE-face-name-test/v-face-memory/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aafc54b"]])

export default __exports__